const projects = [
  {
    id: "1",
    title: "Cultural Center",
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29",
  },
  {
    id: "2",
    title: "Urban Housing",
    image: "https://images.unsplash.com/photo-1492724441997-5dc865305da7",
  },
  {
    id: "3",
    title: "Museum Complex",
    image: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29",
  },
];

export default projects;
